import { BaseModel } from '@kinet-open-network/client/shared/data-access/model';
import {
  IStockMove,
  IStockMoveItem,
  StockMoveExportStatus,
  StockType,
} from '@kinet-open-network/shared/data-access/model';
import { Type } from 'class-transformer';
2;
export class StockMove
  extends BaseModel<StockMove, 'StockMove'>
  implements IStockMove
{
  static override readonly modelName = 'StockMove';

  fromType!: StockType;
  fromId!: string;
  toType!: StockType;
  toId!: string;
  fromLabel?: string;
  toLabel?: string;
  @Type(() => Date)
  moveDate!: Date;
  items?: StockMoveItem[];
  extId?: string;
  exportStatus!: StockMoveExportStatus;
  exportError!: string | null;
  excludeFromAccounting?: boolean;
}

export class StockMoveItem
  extends BaseModel<StockMoveItem, 'StockMove'>
  implements IStockMoveItem
{
  fromId!: string;
  toId!: string;
  @Type(() => Date)
  moveDate!: Date;
  qty!: number;
  qtyFromBefore!: number;
  qtyFromAfter!: number;
  qtyToBefore!: number;
  qtyToAfter!: number;
  stockItemId!: string;
  stockMoveId!: string;
  stockMove?: StockMove;
}
